import { Users, Sparkles, Zap, ArrowUpRight } from 'lucide-react';
import { coBrandTiers, engineSteps } from '../data/mock';

const iconMap = { users: Users, sparkles: Sparkles, zap: Zap };

export default function CoBrand() {
  return (
    <section id="co-brand" className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/5 overflow-hidden">
      {/* Decorative outline letters — clamped smaller on mobile so they don't dwarf headline */}
      <div className="absolute inset-x-0 top-10 outline-text font-display text-[20vw] md:text-[28vw] leading-none tracking-tight pointer-events-none select-none -z-0">
        CO
      </div>
      <div className="absolute inset-x-0 bottom-10 outline-text font-display text-[20vw] md:text-[28vw] leading-none tracking-tight pointer-events-none select-none -z-0">
        BRAND
      </div>

      <div className="relative z-10">
        <div className="flex items-center gap-4 mb-10">
          <span className="w-10 h-px bg-[#FF3D2E]" />
          <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/70">03 / CO-BRAND ENGINE</p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 md:gap-20 items-start mb-16">
          <h2 className="font-display text-[8vw] md:text-[4.5vw] lg:text-[4.5rem] leading-[0.95] tracking-tight">
            <span className="text-white">Brands × Talent ×</span>
            <br />
            <span className="font-script text-[#D7FF3D]">Intelligence.</span>
          </h2>
          <p className="text-white/75 text-base md:text-lg leading-relaxed md:pt-6">
            We don't book influencers — we build co-branded IP with creators, celebrities and synthetic
            talent, then prove the lift with hard analytics.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {coBrandTiers.map((tier) => {
            const Icon = iconMap[tier.icon];
            return (
              <div
                key={tier.title}
                className="group bg-white/[0.03] border border-white/10 hover:border-white/30 hover:bg-white/[0.05] transition-all p-8 flex flex-col"
              >
                <div className="flex items-start justify-between mb-10">
                  <Icon className="w-8 h-8 text-white" strokeWidth={1.4} />
                  <span className="text-[10px] tracking-[0.25em] text-white/70 border border-white/15 px-2.5 py-1">
                    {tier.range}
                  </span>
                </div>
                <h3 className="font-display text-2xl md:text-3xl tracking-tight text-white mb-4">
                  {tier.title}
                </h3>
                <p className="text-white/65 leading-relaxed mb-8">{tier.desc}</p>
                <a
                  href="#contact"
                  className="mt-auto inline-flex items-center gap-2 text-[11px] tracking-[0.25em] text-white/70 hover:text-white border-t border-white/10 pt-5 group-hover:border-white/30 transition-colors"
                >
                  INQUIRE ABOUT THIS TIER
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              </div>
            );
          })}
        </div>

        {/* 4-step engine */}
        <div className="mt-24">
          <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] text-[#FF3D2E] mb-10">
            <span className="w-6 h-px bg-[#FF3D2E]" /> THE 4-STEP ENGINE
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {engineSteps.map((step) => (
              <div key={step.num} className="bg-black p-5 md:p-8 hover:bg-white/[0.03] transition-colors">
                <p className="text-[10px] tracking-[0.3em] text-white/40 mb-4 md:mb-6">{step.num}</p>
                <h4 className="font-display text-2xl md:text-4xl tracking-tight text-white mb-3 leading-tight">{step.title}</h4>
                <p className="text-white/55 text-[13px] md:text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center gap-6">
          <a
            href="#contact"
            className="group inline-flex items-center gap-2 px-6 py-4 bg-[#FF3D2E] text-white text-[11px] tracking-[0.25em] hover:bg-[#ff5446] transition-colors"
          >
            BUILD A CO-BRAND PROGRAM
            <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
          <p className="text-[11px] tracking-[0.3em] text-white/50">
            AVG. CAMPAIGN LIFT: <span className="text-white">+38%</span> · ROAS{' '}
            <span className="text-white">4.7X</span>
          </p>
        </div>
      </div>
    </section>
  );
}
